import React, { memo } from 'react'
import { Typography } from 'transfix-ui/core'
import { TextInput } from 'components/atoms'
import { Autocomplete } from 'components/forms'

interface CarrierInfoProps {
  children: React.ReactNode
}

const CarrierInfo: React.FC<CarrierInfoProps> = ({ children }) => (
  <section>
    <Typography variant='h2'>Add Carrier Information</Typography>
    <div className='mt6'>
      <div className='b mb4'>Carrier Information</div>
      {children}
    </div>
  </section>
)

export default CarrierInfo

export interface IAutocomplete {
  fullSelection: {
    id: string
    cellPhone: string
    phone: string
    name: string
    userType: string
    role: string
  }
}

interface CarrierSearchProps {
  changeCarrierHandler: (selected: IAutocomplete) => void
  carrierId?: string
}

export const CarrierSelect = memo<CarrierSearchProps>(({ carrierId, changeCarrierHandler }) => (
  <Autocomplete
    value={carrierId}
    onChange={changeCarrierHandler}
    type='carrier'
    id='select-carrier-input'
    label='Carrier'
    dataTest='carrier-search'
    required
  />
))

interface CarrierRateProps {
  changeRateHandler: (event: React.ChangeEvent<HTMLInputElement>) => void
  onBlurRateInput: (event: React.FocusEvent<HTMLInputElement>) => void
  rateError: string
}

export const CarrierRate = memo<CarrierRateProps>(
  ({ changeRateHandler, onBlurRateInput, rateError }) => (
    <TextInput
      required
      onChange={changeRateHandler}
      onBlur={onBlurRateInput}
      invalid={Boolean(rateError)}
      validationMessage={rateError}
      clearable={false}
      label='Rate'
      type='number'
      min='0'
      dataTest='rate-entry'
      placeholder='$'
      name='amount'
      className='dialog-medium mt4'
    />
  )
)
